import React, { FC, memo } from 'react';

import ResultFailImg from './result-fail.svg';

interface ResultFailProps {}

const ResultFail: FC<ResultFailProps> = memo(() => {
  return (
    <>
      <img src={ResultFailImg} alt="" className="result__img" />
      <p className="result__text">
        Иногда по&nbsp;доброте душевной вы&nbsp;попадаетесь в&nbsp;ловушки кибермошенников и&nbsp;интернет-троллей.
      </p>
      <p className="result__comment">
        Ещё&nbsp;бы, они ведь так изобретательны! Но&nbsp;и&nbsp;вы&nbsp;будете не&nbsp;промах, если рассекретите ловушки и&nbsp;научите детей и&nbsp;всех близких обходить их&nbsp;стороной.
      </p>
      <a href="https://safe.mail.ru/cybergrooming?utm_source=safe_test&utm_medium=other&utm_campaign=safe_test" target="_blank" rel="noreferrer" className="button -blue">
        Прокачать киберброню
      </a>
      <p className="result__comment -bottom">Усилить защиту ребёнка с <a href="https://trk.mail.ru/c/ieedu7?mt_adset=safemail_test&mt_network=landing&mt_campaign=safemail_kids&mt_creative=1june" target="_blank" rel="noreferrer">Детской почтой</a></p>
    </>
  );
});

export default ResultFail;
